module.exports = __webpack_public_path__ + "img/5-5.18285af0.svg";